import React from "react";
import EAPageHeader from "../shared/EAPageHeader";
import useGdanskSale from "./hooks/useGdanskSale";
import "./GdanskSale.scss";
import GdanskSaleStep1 from "./Steps/GdanskSaleStep1";
import GdanskSaleStep2 from "./Steps/GdanskSaleStep2";
import EAStepper from "../shared/Stepper/EAStepper";
import GdanskSaleStep3 from "./Steps/GdanskSaleStep3";

const GdanskSale: React.FC = () => {
  const { form, setForm, activeStep, setActiveStep, reservationConfig } = useGdanskSale();
  return (
    <div className="gdansk-sale-container">
      <EAPageHeader title="Sklep" />
      {reservationConfig ? (
        <EAStepper
          steps={[
            {
              label: "Wybór usługi",
              content: <GdanskSaleStep1 form={form} setForm={setForm} onNextStep={() => setActiveStep(1)} />,
            },
            {
              label: "Szczegóły",
              content: (
                <GdanskSaleStep2
                  form={form}
                  setForm={setForm}
                  onNextStep={() => setActiveStep(2)}
                  onGoBack={() => setActiveStep(0)}
                />
              ),
            },
            {
              label: "Podsumowanie",
              content: <GdanskSaleStep3 form={form} setForm={setForm} onGoBack={() => setActiveStep(1)} />,
            },
          ]}
          activeStep={activeStep}
          onStepChange={(stepNumber) => setActiveStep(stepNumber)}
        />
      ) : (
        <>Brak konfiguracji rezerwacji</>
      )}
    </div>
  );
};

export default GdanskSale;
